var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductShowcaseInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "248.879 49.341 111.290 111.289",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.046 73.6854V94.5522H259.313V73.6854H301.046ZM259.313 63.2521C253.553 63.2521 248.879 67.9254 248.879 73.6854V94.5522C248.879 100.312 253.553 104.986 259.313 104.986H301.046C306.806 104.986 311.48 100.312 311.48 94.5522V73.6854C311.48 67.9254 306.806 63.2521 301.046 63.2521H259.313ZM349.735 73.6854V129.33H335.824V73.6854H349.735ZM335.824 63.2521C330.064 63.2521 325.391 67.9254 325.391 73.6854V129.33C325.391 135.09 330.064 139.763 335.824 139.763H349.735C355.495 139.763 360.169 135.09 360.169 129.33V73.6854C360.169 67.9254 355.495 63.2521 349.735 63.2521H335.824ZM273.224 129.33H301.046V143.241H273.224V129.33ZM262.791 129.33V143.241C262.791 149.001 267.464 153.675 273.224 153.675H301.046C306.806 153.675 311.48 149.001 311.48 143.241V129.33C311.48 123.57 306.806 118.897 301.046 118.897H273.224C267.464 118.897 262.791 123.57 262.791 129.33Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseInactive);
export default __webpack_public_path__ + "static/media/product-showcase-inactive.c7c5c5e4ff51bcf5219d334946c944f3.svg";
export { ForwardRef as ReactComponent };